/* Back Door product page layer (sections/main-product.liquid, .bd-product).
   Dawn's product-info.js / product-form.js / variant-selects stay in charge of
   variants, cart submission, dynamic checkout and media. This file only:
   1. Sticky fit: the purchase column is sticky (CSS) only while it fits under
      the sticky header - a taller column scrolls with the page, never trapped.
   2. Size required (data-bd-size-pending, decided in Liquid): only when
      MORE THAN ONE variant is purchasable, the product has a size option
      with 2+ values and no ?variant= is in the URL. Then no size starts
      selected, Add to cart reads "Select a size" and is disabled, dynamic
      checkout and the low-stock note stay hidden until the shopper picks a
      size. A product with exactly one purchasable variant loads with it
      already selected (Dawn's own pre-selection) and ready to buy.
   3. Sold-out sizes: Dawn marks unavailable values with .disabled but still
      lets them be picked; here they get the real disabled attribute (not
      selectable, announced as unavailable). Re-applied after every Dawn
      re-render of the picker. */
(function () {
  var SIZE_NAME = /size|waist/i;

  function headerOffset() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  }

  function sizeFieldset(root) {
    var found = null;
    root.querySelectorAll('variant-selects fieldset').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!found && legend && SIZE_NAME.test(legend.textContent)) found = fieldset;
    });
    return found;
  }

  function lockUnavailable(root) {
    root.querySelectorAll('variant-selects input[type="radio"]').forEach(function (input) {
      var unavailable = input.classList.contains('disabled') && !input.checked;
      input.disabled = unavailable;
    });
  }

  function init(root) {
    if (root.dataset.bdProductReady) return;
    root.dataset.bdProductReady = 'true';
    var sectionId = root.dataset.section;

    // 1. Sticky fit
    var info = root.querySelector('.product__info-container');
    function updateSticky() {
      if (!info) return;
      var fits = info.offsetHeight + headerOffset() + 48 <= window.innerHeight;
      info.classList.toggle('bd-sticky-off', !fits);
    }

    // 2. Size required
    var needsSize = false;
    function submitButton() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }
    function applyNeedsSize() {
      var fieldset = sizeFieldset(root);
      var button = submitButton();
      if (!fieldset || !button) return;
      fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.checked = false;
      });
      fieldset.classList.add('bd-size-prompt');
      // A stock note would describe Dawn's pre-selected size, not a chosen one.
      var stock = document.getElementById('Inventory-' + sectionId);
      if (stock) stock.classList.add('hidden');
      button.setAttribute('disabled', 'disabled');
      var label = button.querySelector('span');
      if (label) label.textContent = root.dataset.bdSelectSize || 'Select a size';
      root.classList.add('bd-needs-size');
    }
    function clearNeedsSize() {
      needsSize = false;
      root.classList.remove('bd-needs-size');
      var fieldset = sizeFieldset(root);
      if (fieldset) fieldset.classList.remove('bd-size-prompt');
    }

    if (root.hasAttribute('data-bd-size-pending') && !/[?&]variant=/.test(window.location.search)) {
      var fieldset = sizeFieldset(root);
      var button = submitButton();
      var sizes = fieldset ? fieldset.querySelectorAll('input[type="radio"]').length : 0;
      if (fieldset && sizes > 1 && button && !button.hasAttribute('disabled')) {
        needsSize = true;
        applyNeedsSize();
      }
    }

    // A size pick ends the prompt before Dawn handles the change.
    root.addEventListener(
      'change',
      function (event) {
        var fieldset = sizeFieldset(root);
        if (needsSize && fieldset && fieldset.contains(event.target)) clearNeedsSize();
      },
      true
    );

    // Safety net: never submit while a size is still required.
    root.addEventListener(
      'submit',
      function (event) {
        // Only the main product form - add-on forms (Complete the Fit) inside
        // this section add their own variant and must never be blocked.
        if (!needsSize || !event.target || event.target.id !== 'product-form-' + sectionId) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var first = sizeFieldset(root) && sizeFieldset(root).querySelector('input:not([disabled])');
        if (first) first.focus();
      },
      true
    );

    // After every Dawn re-render (variant change): re-lock sold-out sizes and
    // keep the prompt if another option changed before a size was chosen.
    function afterRender() {
      lockUnavailable(root);
      if (needsSize) applyNeedsSize();
      updateSticky();
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event.data && event.data.sectionId === sectionId) window.requestAnimationFrame(afterRender);
      });
    }

    lockUnavailable(root);
    updateSticky();
    window.addEventListener('resize', updateSticky);
    if ('ResizeObserver' in window && info) new ResizeObserver(updateSticky).observe(info);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('product-info.bd-product').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
